import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { product, heroChips, mockupImage } from '../data/content';
const badges = [{
  label: 'Secure payment',
  Icon: LockIcon
}, {
  label: 'Instant access',
  Icon: ZapIcon
}, {
  label: '7-day guarantee',
  Icon: ShieldCheckIcon
}];
export function Hero() {
  return <header className="w-full border-b border-espresso/10 bg-cream" data-id="element-146" data-mp="128fs5pz8mpyv">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto max-w-5xl px-5 py-14 text-center lg:py-20" data-id="element-147" data-mp="xanq434vpngy">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-148" data-mp="nbf0fmh1qv0e">
          {product.name}
        </p>
        <h1 className="mx-auto mt-5 max-w-4xl font-display text-4xl font-semibold leading-[1.05] tracking-tight text-espresso sm:text-5xl lg:text-6xl" data-id="element-149" data-mp="3czflm08u696k">
          {product.headline}
        </h1>
        <p className="mx-auto mt-5 max-w-2xl font-sans text-lg leading-relaxed text-cocoa" data-id="element-150" data-mp="3j6fxfnpbn9cs">
          {product.subheadline}
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mt-10" data-id="element-151" data-mp="39auqdb5ebiw6">
          <img src={mockupImage} alt="The Braid & Gloss Bible complete package: printed guides, the five bonus workbooks, and the system shown on desktop, tablet and phone" className="mx-auto w-full rounded-2xl shadow-card" loading="eager" data-id="element-152" data-mp="30gge7hg5woha" />
          <p className="mt-5 font-sans text-[11px] font-bold uppercase tracking-[0.16em] text-muted" data-id="element-153" data-mp="2vjg5szvub9n0">
            {product.compareAt} value · Today {product.price} · Instant PDF download
          </p>
        </motion.div>

        <ul className="mt-8 flex flex-wrap justify-center gap-2" data-id="element-154" data-mp="2lmuyu909fogj">
          {heroChips.map(chip => <li key={chip} className="rounded-full border border-espresso/15 bg-sand px-3.5 py-1.5 font-sans text-[11px] font-bold uppercase tracking-[0.1em] text-cocoa" data-id="element-155" data-mp="s3ur9xru3ab5">
              {chip}
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md" data-id="element-156" data-mp="deq4e3a3ghwp">
          <CtaButton label="Get the Bible now" size="large" target="offer" data-id="element-157" data-mp="1b0nmw0oh4n8n" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-158" data-mp="1622hlmud7ddc">
          {badges.map(({
          label,
          Icon
        }) => <li key={label} className="flex items-center gap-2 font-sans text-sm font-medium text-muted" data-id="element-159" data-mp="111yb8pn67z0u">
              <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-160" data-mp="x37am8jhxz8z" />
              {label}
            </li>)}
        </ul>
      </motion.div>
    </header>;
}